import useTranslation from '@/utils/hooks/translation/useTranslation';

import Button from '@/components/base/Button';
import Tooltip from '@/components/base/Tooltip';

export function PastDueButton() {
    const { t } = useTranslation('settings');

    return (
        <Tooltip
            content={t('subscription_invoices_page.new_pricing.past_due_tooltip')}
            position="top">
            <span data-testid="past-due-button-wrapper">
                <Button
                    disabled
                    size="xl"
                    data-testid="button-change-plan-past-due"
                    className="w-full lg:w-max">
                    {t('subscription_invoices_page.change_your_plan')}
                </Button>
            </span>
        </Tooltip>
    );
}
